import axios from 'axios';
import axiosRetry from 'axios-retry';

// Configure axios to automatically retry failed requests
axiosRetry(axios, {
  retries: 3,  // Retry up to 3 times
  retryDelay: axiosRetry.exponentialDelay,  // Wait longer between each retry
  retryCondition: (error) => {
    // Retry on network errors or specific HTTP status codes
    return axiosRetry.isNetworkOrIdempotentRequestError(error) ||
           error.response?.status === 524 ||  // Cloudflare timeout
           error.response?.status === 502 ||  // Bad gateway
           error.response?.status === 503 ||  // Service unavailable
           error.response?.status === 504;    // Gateway timeout
  },
});

export default axios;

